import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
  
@Injectable({
  providedIn: 'root'
})
export class DataTestService {

  protected readonly GET_Values_URL = 'api/Values/';
	
  constructor(private _http : HttpClient) { }


  public GetTestData(): Observable<string[]> {

		return this._http.get<string[]>(`${ this.GET_Values_URL }`);
	}
  
}
